import { ActionType, RootAction } from '@/actions/actiontypes';
import { SplashState } from '@/state/SplashState';

const initialState = SplashState.NONE;

export const splashReducer = (
    splashState: SplashState = initialState,
    action: RootAction
) => {
    switch (action.type) {
        // Start-up
        case ActionType.BOOTSTRAP:
            return action.bootstrappedState.splashState;
        case ActionType.SHOW_SPLASH:
            return action.state;
        case ActionType.SHOW_LOGIN:
            return SplashState.NONE;
        default:
            return splashState;
    }
};
